export const INDUSTRIES= [
  {
    'industry': 'Accommodation and Food Services',
    'sectors': [
      'Accommodation',
      'Cafes, Restaurants and Takeaway Food Services',
      'Clubs (Hospitality)',
      'Pubs, Taverns and Bars'
    ]
  },
  {
    'industry': 'Administrative and Support Services',
    'sectors': [
      'Building Cleaning, Pest Control and Gardening Services',
      'Employment Services',
      'Other Administrative Services',
      'Packaging Services',
      'Travel Agency and Tour Arrangement Services'
    ]
  },
  {
    'industry': 'Agriculture, Forestry and Fishing',
    'sectors': [
      'Agriculture and Fishing Support Services',
      'Aquaculture',
      'Dairy Cattle Farming',
      'Deer Farming',
      'Fishing',
      'Forestry and Logging',
      'Forestry Support Services',
      'Fruit and Tree Nut Growing',
      'Hunting and Trapping',
      'Mushroom and Vegetable Growing',
      'Nursery and Floriculture Production',
      'Other Crop Growing',
      'Other Livestock Farming',
      'Poultry Farming',
      'Sheep, Beef Cattle and Grain Farming'
    ]
  },
  {
    'industry': 'Arts and Recreation Services',
    'sectors': [
      'Amusement and Other Recreation Activities',
      'Creative and Performing Arts Activities',
      'Gambling Activities',
      'Horse and Dog Racing Activities',
      'Museum Operation',
      'Parks and Gardens Operations',
      'Sports and Physical Recreation Activities'
    ]
  },
  {
    'industry': 'Construction',
    'sectors': [
      'Building Completion Services',
      'Building Installation Services',
      'Building Structure Services',
      'Heavy and Civil Engineering Construction',
      'Land Development and Site Preparation Services',
      'Non-Residential Building Construction',
      'Other Construction Services',
      'Residential Building Construction'
    ]
  },
  {
    'industry': 'Education and Training',
    'sectors': [
      'Adult, Community and Other Education',
      'Educational Support Services',
      'Preschool Education',
      'School Education',
      'Tertiary Education'
    ]
  },
  {
    'industry': 'Electricity, Gas, Water and Waste Services',
    'sectors': [
      'Electricity Distribution',
      'Electricity Generation',
      'Electricity Transmission',
      'Gas Supply',
      'On Selling Electricity and Electricity Market Operation',
      'Waste Collection Services',
      'Waste Treatment, Disposal and Remediation Services',
      'Water Supply, Sewerage and Drainage Services'
    ]
  },
  {
    'industry': 'Financial and Insurance Services',
    'sectors': [
      'Auxiliary Finance and Investment Services',
      'Auxiliary Insurance Services',
      'Central Banking',
      'Depository Financial Intermediation',
      'Financial Asset Investing',
      'Health and General Insurance',
      'Life Insurance',
      'Non-Depository Financing',
      'Superannuation Funds'
    ]
  },
  {
    'industry': 'Health Care and Social Assistance',
    'sectors': [
      'Allied Health Services',
      'Child Care Services',
      'Hospitals',
      'Medical Services',
      'Other Health Care Services',
      'Other Social Assistance Services',
      'Pathology and Diagnostic Imaging Services',
      'Residential Care Services'
    ]
  },
  {
    'industry': 'Information Media and Telecommunications',
    'sectors': [
      'Data Processing, Web Hosting and Electronic Information Storage Services',
      'Internet Publishing and Broadcasting',
      'Internet Service Providers and Web Search Portals',
      'Libraries and Archives',
      'Motion Picture and Video Activities',
      'Newspaper, Periodical, Book and Directory Publishing',
      'Other Information Services',
      'Radio Broadcasting',
      'Software Publishing',
      'Sound Recording and Music Publishing',
      'Telecommunications Services',
      'Television Broadcasting'
    ]
  },
  {
    'industry': 'Manufacturing',
    'sectors': [
      'Bakery Product Manufacturing',
      'Basic Chemical Manufacturing',
      'Basic Ferrous Metal Manufacturing',
      'Basic Ferrous Metal Product Manufacturing',
      'Basic Non-Ferrous Metal Manufacturing',
      'Basic Non-Ferrous Metal Product Manufacturing',
      'Basic Polymer Manufacturing',
      'Beverage Manufacturing',
      'Cement, Lime, Plaster and Concrete Product Manufacturing',
      'Ceramic Product Manufacturing',
      'Cigarette and Tobacco Product Manufacturing',
      'Cleaning Compound and Toiletry Preparation Manufacturing',
      'Clothing and Footwear Manufacturing',
      'Computer and Electronic Equipment Manufacturing',
      'Converted Paper Product Manufacturing',
      'Dairy Product Manufacturing',
      'Domestic Appliance Manufacturing',
      'Electrical Equipment Manufacturing',
      'Fertiliser and Pesticide Manufacturing',
      'Fruit and Vegetable Processing',
      'Furniture Manufacturing',
      'Glass and Glass Product Manufacturing',
      'Grain Mill and Cereal Product Manufacturing',
      'Iron and Steel Forging',
      'Knitted Product Manufacturing',
      'Leather Tanning, Fur Dressing and Leather Product Manufacturing',
      'Log Sawmilling and Timber Dressing',
      'Meat and Meat Product Manufacturing',
      'Metal Container Manufacturing',
      'Motor Vehicle and Motor Vehicle Part Manufacturing',
      'Natural Rubber Product Manufacturing',
      'Oil and Fat Manufacturing',
      'Other Basic Chemical Product Manufacturing',
      'Other Fabricated Metal Product Manufacturing',
      'Other Food Product Manufacturing',
      'Other Machinery and Equipment Manufacturing',
      'Other Manufacturing',
      'Other Non-Metallic Mineral Product Manufacturing',
      'Other Transport Equipment Manufacturing',
      'Other Wood Product Manufacturing',
      'Petroleum and Coal Product Manufacturing',
      'Pharmaceutical and Medicinal Product Manufacturing',
      'Polymer Product Manufacturing',
      'Printing and Printing Support Services',
      'Professional and Scientific Equipment Manufacturing',
      'Pulp, Paper and Paperboard Manufacturing',
      'Pump, Compressor, Heating and Ventilation Equipment Manufacturing',
      'Reproduction of Recorded Media',
      'Seafood Processing',
      'Sheet Metal Product Manufacturing (except Metal Structural and Container Products)',
      'Specialised Machinery and Equipment Manufacturing',
      'Structural Metal Product Manufacturing',
      'Sugar and Confectionery Manufacturing',
      'Textile Manufacturing',
      'Textile Product Manufacturing'
    ]
  },
  {
    industry: 'Mining',
    sectors: [
      'Coal Mining',
      'Construction Material Mining',
      'Exploration',
      'Metal Ore Mining',
      'Oil and Gas Extraction',
      'Other Mining Support Services',
      'Other Non-Metallic Mineral Mining and Quarrying]'
    ]
  },
  {
    industry: 'Other Services',
    sectors: [
      'Automotive Repair and Maintenance',
      'Civic, Professional and Other Interest Group Services',
      'Funeral, Crematorium and Cemetery Services',
      'Machinery and Equipment Repair and Maintenance',
      'Other Personal Services',
      'Other Repair and Maintenance',
      'Personal Care Services',
      'Private Households Employing Staff and Undifferentiated Goods and Service-Producing Activities of Households for Own Use',
      'Religious Services'
    ]
  },
  {
    industry: 'Professional, Scientific and Technical Services',
    sectors: [
      'Advertising Services',
      'Architectural, Engineering and Technical Services',
      'Computer System Design and Related Services',
      'Legal and Accounting Services',
      'Management and Related Consulting Services',
      'Market Research and Statistical Services',
      'Other Professional, Scientific and Technical Services',
      'Scientific Research Services',
      'Veterinary Services'
    ]
  },
  {
    industry: 'Public Administration and Safety',
    sectors: [
      'Central Government Administration',
      'Defence',
      'Government Representation',
      'Justice',
      'Local Government Administration',
      'Public Order and Safety Services',
      'Regulatory Services',
      'State Government Administration'
    ]
  },
  {
    industry: 'Rental, Hiring and Real Estate Services',
    sectors: [
      'Farm Animal and Bloodstock Leasing',
      'Motor Vehicle and Transport Equipment Rental and Hiring',
      'Non-Financial Intangible Assets (Except Copyrights) Leasing',
      'Other Goods and Equipment Rental and Hiring',
      'Property Operators',
      'Real Estate Services'
    ]
  },
  {
    industry: 'Retail Trade',
    sectors: [
      'Clothing, Footwear and Personal Accessory Retailing',
      'Department Stores',
      'Electrical and Electronic Goods Retailing',
      'Fuel Retailing',
      'Furniture, Floor Coverings, Houseware and Textile Goods Retailing',
      'Hardware, Building and Garden Supplies Retailing',
      'Motor Vehicle Parts and Tyre Retailing',
      'Motor Vehicle Retailing',
      'Non-Store Retailing',
      'Pharmaceutical and Other Store-Based Retailing',
      'Recreational Goods Retailing',
      'Retail Commission-Based Buying and/or Selling',
      'Specialised Food Retailing',
      'Supermarket and Grocery Stores'
    ]
  },
  {
    industry: 'Transport, Postal and Warehousing',
    sectors: [
      'Air and Space Transport',
      'Airport Operations and Other Air Transport Support Services',
      'Other Transport Support Services',
      'Pipeline and Other Transport',
      'Postal and Courier Pick-up and Delivery Services',
      'Rail Freight Transport',
      'Rail Passenger Transport',
      'Road Freight Transport',
      'Road Passenger Transport',
      'Scenic and Sightseeing Transport',
      'Warehousing and Storage Services',
      'Water Freight Transport',
      'Water Passenger Transport',
      'Water Transport Support Services'
    ]
  },
  {
    industry: 'Wholesale Trade',
    sectors: [
      'Agricultural Product Wholesaling',
      'Commission-Based Wholesaling',
      'Furniture, Floor Covering and Other Goods Wholesaling',
      'Grocery, Liquor and Tobacco Product Wholesaling',
      'Mineral, Metal and Chemical Wholesaling',
      'Motor Vehicle and Motor Vehicle Parts Wholesaling',
      'Other Machinery and Equipment Wholesaling',
      'Pharmaceutical and Toiletry Goods Wholesaling',
      'Specialised Industrial Machinery and Equipment Wholesaling',
      'Textile, Clothing and Footwear Wholesaling',
      'Timber and Hardware Goods Wholesaling'
    ]
  }
]
export const PRESENTER_FIELDS = {
  Employer: [
    {
      name: 'name',
      label: 'Employer Name',
      type: 'string',
    },
    {
      name: 'numberOfPresenters',
      label: 'Number of Employers',
      type: 'number',
    },
  ],
  GTO: [
    {
      name: 'name',
      label: 'Name of GTO',
      description: 'Group Training Organisation',
      type: 'string',
    },
  ],
  HTC: [
    {
      name: 'name',
      label: 'Name of HTC',
      description: 'Head Teacher Careers',
      type: 'string',
    },
    {
      name: 'numberOfPresenters',
      label: 'Number of HTCs',
      type: 'number',
    },
  ],
  'Job Readiness Provider': [
    {
      name: 'numberOfPresenters',
      label: 'Number of presenters from job readiness',
      type: 'number',
    },
  ],
  RIEP: [
    {
      name: 'numberOfPresenters',
      label: 'Number of presenters from RIEP',
      type: 'number',
    },
  ],
  RTO: [
    {
      name: 'name',
      label: 'Name of RTO',
      description: 'Registered Training Organisation',
      type: 'string',
    },
  ],
  SBATEO: [
    {
      name: 'numberOfPresentors',
      label: 'Number of SBATEOs',
      type: 'number',
    },
    {
      name: 'name',
      label: 'SBATEO names',
      description: 'SBAT Engagement Officer (SBAT = School Based Apprenticeship or Traineeship)',
      type: 'string',
    },
  ],
  'VET Ambassadors': [
    {
      name: 'numberOfPresenters',
      label: 'Number of VET Ambassadors',
      type: 'number',
    },
  ],
  Other: [
    {
      name: 'name',
      label: 'Please specify',
      type: 'string',
    },
  ],
};

export const PRESENTER_TYPES = [
  {
    presenterType: 'Employer',
    fields: [
      {
        'name': 'name',
        'label': 'Employer Name',
        'type': 'string'
      },
      {
        'name': 'numberOfPresentors',
        'label': 'Number of Employers',
        'type': 'number'
      }
    ]
  },
  {
    presenterType: 'GTO',
    fields: [
      {
        'name': 'nameOfGTO',
        'label': 'Name of GTO',
        'type': 'string'
      }
    ]
  },
  {
    presenterType: 'Job Readiness Provider',
    fields: [
      {
        'name': 'numberOfJRPs',
        'label': 'Number of presenters from job readiness',
        'type': 'number'
      }
    ]
  },
  {
    presenterType: 'RIEP',
    fields: [
      {
        'name': 'numberOfRIEPs',
        'label': 'Number of presenters from RIEP',
        'type': 'number'
      }
    ]
  },
  {
    presenterType: 'RTO',
    fields: [
      {
        'name': 'nameOfRTOs',
        'label': 'Name of RTO',
        'type': 'string'
      }
    ]
  },
  {
    presenterType: 'SBATEO',
    fields: [
      {
        'name': 'numberOfSBATEOs',
        'label': 'Number of SBATEOs',
        'type': 'number'
      },
      {
        'name': 'nameOfRTOs',
        'label': 'SBATEO names',
        'type': 'string'
      }
    ]
  },
  {
    presenterType: 'VET Ambassadors',
    fields: [
      {
        'name': 'numberOfVETs',
        'label': 'Number of VET Ambassadors',
        'type': 'number'
      }
    ]
  },
  {
    presenterType: 'Other',
    fields: [
      {
        'name': 'nameOfOthers',
        'label': 'Please specify',
        'type': 'string'
      }
    ]
  }
];
export const SKILL_AREAS = [
  'Construction (infrastructure and housing)',
  'Net Zero and energy transition',
  'Digital and cyber',
  'Care and support economy',
  'Agriculture and agrifood',
  'Advanced manufacturing'
]
